{
  "__review_clinicalData": "Backend/clinician-authored API data (allergen/medication/problem/provider/result names, values, units, ranges, comments, message bodies) — Phase 9, do not translate",
  "enums": {
    "appointmentStatus": {
      "scheduled": "Dijadualkan",
      "confirmed": "Disahkan",
      "completed": "Selesai",
      "cancelled": "Dibatalkan",
      "no-show": "Tidak hadir",
      "checked-in": "Telah mendaftar"
    },
    "resultStatus": {
      "final": "Muktamad",
      "preliminary": "Awalan",
      "corrected": "Dibetulkan"
    },
    "allergySeverity": {
      "severe": "Teruk",
      "high": "Tinggi",
      "moderate": "Sederhana"
    },
    "nationalIdType": {
      "NRIC": "NRIC (Singapura)",
      "HKID": "HKID (Hong Kong)",
      "MyKad": "MyKad (Malaysia)",
      "Aadhaar": "Aadhaar (India)",
      "KTP": "KTP (Indonesia)",
      "Passport": "Pasport"
    },
    "messageSenderType": {
      "provider": "Penyedia",
      "patient": "Pesakit"
    }
  },
  "form": {
    "validation": {
      "passwordMismatch": "Kata laluan tidak sepadan",
      "passwordMinLength": "Kata laluan mestilah sekurang-kurangnya 8 aksara"
    }
  },
  "labels": {
    "abnormal": "Tidak normal"
  },
  "pages": {
    "layout": {
      "nav": {
        "myHealth": "Kesihatan Saya",
        "results": "Keputusan",
        "appointments": "Temu Janji",
        "messages": "Mesej",
        "forms": "Borang"
      },
      "signOut": "Log keluar",
      "signOutAria": "Log keluar",
      "navAria": "Navigasi portal",
      "footer": "Portal Pesakit VynaEMR — FLOSTEL Healthcare IT"
    },
    "login": {
      "subtitle": "Portal Pesakit",
      "labels": {
        "email": "E-mel",
        "password": "Kata laluan"
      },
      "placeholders": {
        "email": "you@example.com",
        "password": "Masukkan kata laluan anda"
      },
      "button": {
        "signIn": "Log masuk",
        "signingIn": "Sedang log masuk..."
      },
      "toast": {
        "welcome": "Selamat kembali!",
        "invalid": "E-mel atau kata laluan tidak sah"
      },
      "links": {
        "noAccount": "Tiada akaun?",
        "register": "Daftar"
      }
    },
    "dashboard": {
      "greeting": {
        "morning": "Selamat pagi",
        "afternoon": "Selamat tengah hari",
        "evening": "Selamat malam",
        "fallbackName": "anda"
      },
      "subtitle": "Berikut ringkasan kesihatan anda.",
      "error": "Ringkasan kesihatan anda tidak dapat dimuatkan. Sila cuba lagi nanti.",
      "demographics": {
        "ageLabel": "Umur {{age}}",
        "bloodTypeLabel": "Jenis darah: {{bloodType}}"
      },
      "quickLinks": {
        "results": "Keputusan",
        "appointments": "Temu Janji",
        "messages": "Mesej",
        "forms": "Borang"
      },
      "sections": {
        "allergies": "Alahan",
        "activeMedications": "Ubat Aktif",
        "activeProblems": "Masalah Aktif",
        "upcomingAppointments": "Temu Janji Akan Datang",
        "recentResults": "Keputusan Terkini",
        "immunizations": "Imunisasi",
        "emergencyContact": "Kenalan Kecemasan"
      },
      "states": {
        "noAllergies": "Tiada alahan dalam rekod.",
        "noMedications": "Tiada ubat aktif.",
        "noAppointments": "Tiada temu janji akan datang.",
        "noResults": "Tiada keputusan terkini."
      },
      "moreCount": "+{{count}} lagi",
      "sinceDate": "sejak {{date}}",
      "doseNumber": "Dos {{number}}",
      "viewAll": "Lihat semua",
      "providerTBD": "Doktor belum ditetapkan"
    },
    "register": {
      "subtitle": "Cipta akaun anda",
      "labels": {
        "fullName": "Nama Penuh",
        "email": "E-mel",
        "dateOfBirth": "Tarikh Lahir",
        "phone": "Telefon",
        "mrn": "MRN (Nombor Rekod Perubatan)",
        "idType": "Jenis Pengenalan",
        "idNumber": "Nombor Pengenalan",
        "password": "Kata laluan",
        "confirmPassword": "Sahkan Kata laluan"
      },
      "placeholders": {
        "fullName": "Nama penuh anda",
        "email": "you@example.com",
        "phone": "+65 9123 4567",
        "mrn": "e.g. P0000000001",
        "idNumber": "Nombor pengenalan anda",
        "password": "Sekurang-kurangnya 8 aksara",
        "confirmPassword": "Masukkan semula kata laluan anda",
        "selectIdType": "Pilih..."
      },
      "mrnHint": "Untuk memautkan akaun anda kepada rekod perubatan, sila berikan MRN atau Nombor Pengenalan anda.",
      "button": {
        "createAccount": "Cipta Akaun",
        "creatingAccount": "Sedang mencipta akaun..."
      },
      "toast": {
        "success": "Pendaftaran berjaya. Sila log masuk.",
        "failure": "Pendaftaran gagal. Sila cuba lagi."
      },
      "links": {
        "haveAccount": "Sudah ada akaun?",
        "signIn": "Log masuk"
      },
      "aria": {
        "dateOfBirth": "Tarikh Lahir"
      }
    },
    "appointments": {
      "title": "Temujanji",
      "subtitle": "Lihat dan urus temujanji anda",
      "error": "Tidak dapat memuatkan temujanji. Sila cuba lagi sebentar lagi.",
      "sections": {
        "upcoming": "Akan Datang",
        "past": "Lepas"
      },
      "states": {
        "noUpcoming": "Tiada temujanji akan datang.",
        "noPast": "Tiada temujanji lepas."
      },
      "reasonLabel": "Sebab: {{reason}}",
      "instructionsLabel": "Arahan: {{instructions}}",
      "durationMinutes": "{{minutes}} minit",
      "actions": {
        "cancel": "Batalkan",
        "confirmCancel": "Sahkan",
        "cancelling": "Membatalkan...",
        "keep": "Jangan Batal"
      },
      "toast": {
        "cancelSubmitted": "Permintaan pembatalan telah dihantar. Pasukan penjagaan anda akan mengesahkannya.",
        "cancelFailed": "Gagal membatalkan temujanji. Sila hubungi pejabat."
      }
    },
    "results": {
      "title": "Keputusan Saya",
      "subtitle": "Lihat keputusan ujian makmal dan pengimejan anda",
      "error": "Tidak dapat memuatkan keputusan. Sila cuba lagi sebentar lagi.",
      "referenceRange": "(Ruj: {{range}})",
      "states": {
        "noResults": "Tiada keputusan tersedia."
      }
    },
    "messages": {
      "title": "Mesej",
      "subtitle": "Berkomunikasi dengan pasukan penjagaan anda",
      "error": "Tidak dapat memuatkan mesej. Sila cuba lagi sebentar lagi.",
      "fromSender": "daripada {{name}}",
      "labels": {
        "subject": "Subjek",
        "message": "Mesej",
        "reply": "Balasan"
      },
      "placeholders": {
        "subject": "Subjek mesej",
        "message": "Taipkan mesej anda...",
        "reply": "Taipkan balasan anda..."
      },
      "actions": {
        "newMessage": "Mesej Baharu",
        "back": "Kembali ke senarai mesej",
        "sendMessage": "Hantar Mesej",
        "sendReply": "Hantar Balasan",
        "sending": "Menghantar..."
      },
      "states": {
        "noMessages": "Belum ada mesej."
      },
      "thread": {
        "fromSenderWithType": "Daripada {{name}} ({{type}})"
      },
      "compose": {
        "title": "Mesej Baharu",
        "subtitle": "Mesej anda akan dihantar kepada pasukan penjagaan anda."
      },
      "toast": {
        "sent": "Mesej dihantar",
        "sendFailed": "Gagal menghantar mesej"
      }
    },
    "forms": {
      "title": "Borang",
      "subtitle": "Lengkapkan borang dan soal selidik yang diperlukan",
      "error": "Tidak dapat memuatkan borang. Sila cuba lagi sebentar.",
      "sections": {
        "pending": "Belum Lengkap",
        "completed": "Lengkap"
      },
      "labels": {
        "required": "Diperlukan"
      },
      "placeholders": {
        "select": "Pilih..."
      },
      "actions": {
        "fillOut": "Isi",
        "back": "Kembali ke borang",
        "submit": "Hantar Borang",
        "submitting": "Menghantar..."
      },
      "states": {
        "noPending": "Tiada borang yang belum lengkap.",
        "noCompleted": "Tiada borang yang lengkap.",
        "noFields": "Borang ini tiada medan untuk diisi."
      },
      "toast": {
        "submitted": "Borang berjaya dihantar",
        "submitFailed": "Gagal menghantar borang"
      }
    }
  }
}
